import React, { PureComponent } from 'react';
import Spinner from '@atlaskit/spinner';
import Tabs from '@atlaskit/tabs';
import { FieldText } from '@atlaskit/field-text';
import { akGridSize } from '@atlaskit/util-shared-styles';
import { BASE_URL, TABS } from '../config';

import DynamicTable from '@atlaskit/dynamic-table';
import { akGridSizeUnitless } from '@atlaskit/util-shared-styles';
import styled from 'styled-components';
import { Link } from 'react-router';
import RelativeDate from '../components/RelativeDate';


const defaultTabIndex = 1;

const RowCell = styled.div`
  padding-bottom: ${akGridSizeUnitless}px;
  padding-top: ${akGridSizeUnitless}px;
`;

const head = {
  cells: [
    {
      key: 'name',
      content: 'Name',
      isSortable: true,
      width: 15,
    },
    {
      key: 'description',
      content: 'Description',
      shouldTruncate: true,
      isSortable: false,
      width: 45,
    },
    {
      key: 'updated',
      content: 'Updated',
      shouldTruncate: true,
      isSortable: true,
      width: 20,
    },
    {
      key: 'maintainers',
      content: 'Maintainers',
      shouldTruncate: true,
      isSortable: false,
      width: 20,
    },
  ],
};

export default class TabbedComponents extends PureComponent {
  state = {
    selectedTabIndex: defaultTabIndex,
    showInternal: false,
    filter: '',
  }

  renderHeader = () => {
    const { header: Header, extraProps = {} } = this.props;
    if (Header) {
      return <Header {...extraProps} />
    }
    return <span />;
  }

  onShowInternalChange = (event) => {
    this.setState({ showInternal: event.target.checked});
  }

  filterByTyping = (event) => {
    this.setState({ filter: event.target.value})
  }

  shouldHideInternal = (component) => {
    return !this.state.showInternal && component.keywords.indexOf('internal') > -1;
  }

  isMaintainerFound = (component) => {
    return !!(component.maintainers.filter((val) => {
      return val.name.indexOf(this.state.filter) > -1
    }).length);
  }

  isComponentFound = (component) => {
    return component.name.indexOf(this.state.filter) > -1;
  }

  filterComponents = (component) => {
    if (
      this.shouldHideInternal(component) ||
      (this.state.filter
        && !this.isMaintainerFound(component)
        && !this.isComponentFound(component)
      )
    ) {
      return false;
    }
    return true;
  }

  renderFilters = () => {
    return <div style={{padding: `${akGridSizeUnitless * 2}px 0`, display: 'flex', alignItems: 'center' }}>
      <label style={{ paddingRight: akGridSize }}>
        <input
          type="checkbox"
          checked={this.state.showInternal}
          onChange={this.onShowInternalChange}
          style={{ marginLeft: 0 }}
        /> Internal
      </label>
      <div style={{ width: `${akGridSizeUnitless * 37}px` }}>
        <FieldText compact shouldFitContainer isLabelHidden value={this.state.filter} onChange={this.filterByTyping} placeholder="Component's name or maintainer" />
      </div>
    </div>
  }

  renderRow = (component) => {
    const {
      name,
      fullName,
      description,
      version,
      publishTime,
      maintainers
    } = component;

    return {
      cells: [
        {
          key: name,
          content: (
            <RowCell>
              <Link to={`${BASE_URL}/${name}/latest/index.html`}>{name}</Link>
            </RowCell>
          ),
        },
        {
          key: description,
          shouldTruncate: true,
          content: (
            <RowCell>{description}</RowCell>
          ),
        },
        {
          key: publishTime,
          content: (
            <RowCell>
              <a href={`https://www.npmjs.com/package/${fullName}`}>
                {version}
              </a>
              &nbsp;
              {
                publishTime ? (
                  <span>
                    (<RelativeDate iso={publishTime} />)
                  </span>
                ) : null
              }
            </RowCell>
          ),
        },
        {
          content: (
            <RowCell>
              { maintainers.map(val => val.name).join(', ') }
            </RowCell>
          )
        },
      ],
    }
  }

  renderTabContent = () => {
    const { components } = this.props;
    const selectedTab = TABS[this.state.selectedTabIndex];
    const filteredComponents = components.filter(selectedTab.filter);
    return (
      <div style={{width: '100%'}}>
        {this.renderFilters()}
        <DynamicTable
          head={head}
          rows={
            filteredComponents.filter(this.filterComponents).map((tabComponent) => (
              this.renderRow(tabComponent)
            ))
          }
          isFixedSize
          defaultSortKey="name"
          defaultSortOrder="ASC"
        />
      </div>
    );
  }

  handleTabChange = (selectedTabIndex) => {
    this.setState({ selectedTabIndex });
  }

  render(elem) {
    const { components } = this.props;
    if (!components || !components.length) return <Spinner />;

    const Header = this.renderHeader;
    const Content = this.renderTabContent;
    return (
      <div>
        <Header />
        <Tabs
          onSelect={this.handleTabChange}
          tabs={TABS.map((tab, tabIndex) => ({
            defaultSelected: tabIndex === defaultTabIndex,
            label: tab.title,
            content: <Content />
          }))}
        />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/TabbedComponents.jsx